import { Inject, Injectable } from '@angular/core'
import { initializeApp } from 'firebase/app'
import { getMessaging, Messaging } from 'firebase/messaging'
import { RUNTIME_CONFIG, RuntimeConfig, toFirebaseConfig } from '@config/runtime-config'

/**
 * Inicialização do Firebase App + Messaging usando o SDK modular puro (pacote `firebase`), sem o
 * wrapper `@angular/fire`. O wrapper só adiciona injeção Angular (zone-wrapping + DI tokens) em
 * cima das mesmas funções expostas aqui (`initializeApp`, `getMessaging`) — ao remover o vínculo de
 * peer dependency com `@angular/core`, o upgrade de major do Angular deixa de depender de quando o
 * `@angular/fire` publica suporte estável para a versão em uso.
 *
 * Ver specs/014-upgrade-angular-18-20/plan.md, seção 5A.
 */
@Injectable({
	providedIn: 'root'
})
export class FirebaseMessagingService {
	readonly messaging: Messaging

	constructor(@Inject(RUNTIME_CONFIG) runtimeConfig: RuntimeConfig) {
		const app = initializeApp(toFirebaseConfig(runtimeConfig))
		this.messaging = getMessaging(app)
	}
}
